// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"04553bbfc9bfd18c06c3","293":"3659bc6a904eea0a009c","452":"e0239ebc16ecec20e6f8"}[chunkId] + ".js";
};